import apiClient from './client';

export type ApiWorkoutType = {
  workout_template_type: string;
  fitness_level: string;
};

export type ApiModification = {
  id: number;
  unique_name: string;
  name: string;
  workout_types: ApiWorkoutType[];
};

export type ApiUserModification = {
  id: number;
  modification: ApiModification;
};

export type UserData = {
  id: number;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  is_internal: boolean | null;
  properties?: Record<string, unknown> | null;
  modifications?: ApiUserModification[] | null;
};

type GetUserResponse = {
  success: boolean;
  data: {
    user: UserData;
  } | null;
  error: string | null;
};

export async function getUserFromToken(): Promise<GetUserResponse> {
  const response = await apiClient.get<GetUserResponse>('/token');
  console.log('getUserFromToken response', response.data);

  return response.data;
}
